/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveWalletRequestBody
 */
export interface RemoveWalletRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveWalletRequestBody
     */
    walletId: string;
}

export function RemoveWalletRequestBodyFromJSON(json: any): RemoveWalletRequestBody {
    return RemoveWalletRequestBodyFromJSONTyped(json, false);
}

export function RemoveWalletRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveWalletRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'walletId': json['walletId'],
    };
}

export function RemoveWalletRequestBodyToJSON(value?: RemoveWalletRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'walletId': value.walletId,
    };
}


